// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".apply-button[data-v-01dd89e4]{margin-bottom:10px}", ""]);
// Exports
module.exports = exports;
